
  document.addEventListener("DOMContentLoaded", function () {
     window.addEventListener("load", function () {
      const accepted = getAcceptedValue();
      console.log({ load: accepted });
      if (!accepted) {

        document.querySelector(".dialog-pop-up").style.display = "block";
        document.querySelector(".dialog-pop-up").style.opacity = 0;

        fadeIn(document.querySelector(".dialog-pop-up"), 1500);


        document
          .querySelector("#closeIconContainer")
          .addEventListener("click", function () {
            // clearInterval(myTimer);
            fadeOut(document.querySelector(".dialog-pop-up"), 500);
            setAcceptedValue();
          });


        document
          .querySelector("#Subscribe")
          .addEventListener("click", function (event) {
            console.log("evento submit")
            //event.preventDefault();
            setAcceptedValue();
            location.reload();
          });
      }
    }); 

  /* window.addEventListener("load", function () {
    const accepted = getAcceptedValue();
    console.log({ load: accepted });
    if (!accepted) {
      const modal = document.querySelector(".dialog-pop-up");
      const closeButton = document.querySelector("#closeIconContainer");
      const form = document.querySelector("#ContactFooter");

      modal.style.display = "block";
      modal.style.opacity = 0;

      fadeIn(modal, 1500);

      closeButton.addEventListener("click", function () {
        fadeOut(modal, 500);
      });

      form.addEventListener("submit", function (event) {
        console.log("evento submit");
        event.preventDefault(); // Evita el envío del formulario por defecto

        // Envía el formulario de manera asíncrona si es necesario
          console.log({action: form.action});
        fetch(form.action, {
          method: form.method,
          body: new FormData(form),
        })
        .then(response => response.json())
        .then(data => {
          console.log("Formulario enviado", data);
          // Oculta el modal después de enviar el formulario
          fadeOut(modal, 500);
        })
        .catch(error => {
          console.error("Error al enviar el formulario", error);
        });

        // Si no deseas manejar el envío asíncrono, puedes comentar el bloque anterior y usar:
        // setAcceptedValue();
        // fadeOut(modal, 500);
      });
    }
  }); */
    
    function fadeIn(element, duration) {
      let opacity = 0;
      element.style.display = "block";
      element.style.top = 0;
      element.style.left = 0;
      element.style.position = "absolute";
      let interval = 80;
      let increment = interval / duration;

      function increase() {
        opacity += increment;
        if (opacity >= 1) {
          opacity = 1;
        }
        element.style.opacity = opacity;
        if (opacity < 1) {
          setTimeout(increase, interval);
        }
      }
      increase();
    }

    function fadeOut(element, duration) {
      let opacity = 1;
      let interval = 80;
      let decrement = interval / duration;

      function decrease() {
        opacity -= decrement;
        if (opacity <= 0) {
          opacity = 0;
          element.style.display = "none";
        }
        element.style.opacity = opacity;
        if (opacity > 0) {
          setTimeout(decrease, interval);
        }
      }
      decrease();
    }
  });

  const setAcceptedValue = () => {
    const data = { accepted: true }; // Store an object with 'accepted' property
    const jsonString = JSON.stringify(data);
    localStorage.setItem("terms-use", jsonString);
  };

  const getAcceptedValue = () => {
    const item = localStorage.getItem("terms-use");
    console.log(item);
    if (!item) {
      // Check for null or undefined more cleanly
      return false;
    }
    try {
      const parsed = JSON.parse(item);
      return parsed || false; // Safely assume 'accepted' might not be present
    } catch (error) {
      console.error("Parsing error in getAcceptedValue:", error);
      return false; // Return false if parsing fails
    }
  };
